module.exports = __webpack_public_path__ + "static/media/destination.da36a39a.svg";